import { useMemo, useState } from 'react';
import DashboardCompaniesTable from './DashboardCompaniesTable/DashboardCompaniesTable';
import DashboardCompaniesFiltersModal from './DashboardCompaniesFiltersModal/DashboardCompaniesFiltersModal';
import { DashboardCompaniesContext } from './DashboardCompanies.context';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import { DashboardCompaniesFilters } from './DashboardCompanies.types';

export default () => {
  const [isFiltersModalOpen, setFiltersModalOpen] = useState(false);

  const [filters, setFilters] = useState<DashboardCompaniesFilters>({
    domains: [],
    fieldsOfActivity: [],
    region: undefined,
    department: undefined,
  });

  const contextValue = useMemo(
    () => ({
      isFiltersModalOpen,
      setFiltersModalOpen,
      filters,
      setFilters,
    }),
    [isFiltersModalOpen, setFiltersModalOpen, filters, setFilters]
  );

  return (
    <DashboardCompaniesContext.Provider value={contextValue}>
      <DashboardLayout>
        <DashboardCompaniesTable />
        <DashboardCompaniesFiltersModal isOpen={isFiltersModalOpen} setOpen={setFiltersModalOpen} />
      </DashboardLayout>
    </DashboardCompaniesContext.Provider>
  );
};
